// share-providers/x.js
export const shareOnX = (url, title = "") => {
  const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    url
  )}&text=${encodeURIComponent(title)}`
  window.open(shareUrl, "twitter-share-dialog", "width=626,height=436")
}
